import _ from 'lodash';
import React from 'react';
import { useApolloClient } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import PresentationManager from '$lib/presentationManager';
import { track } from '$lib/tracking';
import MODE from '$components/review/mode';
import ReviewRotate from '../ReviewRotate';
import ReviewConnectionCheck from '../ReviewConnectionCheck';
import ReviewMain from '../ReviewMain';
import styles from './styles.scss';

const createPresentationManager = ({ client, debug, mode, sessionUuid }) => {
  if (debug) {
    const nop = new Proxy(
      {},
      {
        get(_target, _name) {
          return () => {};
        },
      }
    );
    return nop;
  }

  const presentationManager = new PresentationManager({ client, mode, sessionUuid });
  return presentationManager;
};

const ReviewWrapper = (props) => {
  const client = useApolloClient();
  const history = useHistory();
  const { match, mode, userExamUuid, essayResponseUuid } = props;
  const {
    params: { productSlug },
  } = match;
  track('Quiz | Viewed', { productSlug });

  const debug = (() => {
    const { search } = window.location;
    if (_.isEmpty(search)) {
      return null;
    }

    const query = search.substring(1);
    const parsed = qs.parse(query);
    const { debug: parsedDebug } = parsed;
    return parsedDebug;
  })();

  const presentationManager = createPresentationManager({
    client,
    debug,
    mode,
    sessionUuid: userExamUuid,
  });

  return (
    <div className={styles.layout}>
      <ReviewConnectionCheck />
      <ReviewRotate />
      <ReviewMain
        client={client}
        history={history}
        match={match}
        mode={debug ? MODE.debug : mode}
        debug={debug}
        presentationManager={presentationManager}
        productSlug={productSlug}
        userExamUuid={userExamUuid}
        essayResponseUuid={essayResponseUuid}
      />
    </div>
  );
};

export default ReviewWrapper;
